import { Box, Stack, useTheme } from "@mui/material";
import { DateTime } from "luxon";
import { useAppSelector } from "utils/redux/hooks";
import {
  selectActiveToolCall,
  selectCompletedToolCalls,
  selectIsStreaming,
  selectSendMessageStatus,
  selectStreamingResponse,
} from "app/containers/Chatbot/slice";
import {
  ToolCallPending,
  ToolCallCompleted,
} from "app/containers/Chatbot/ToolCallAccordion";
import { BoAvatar, Message } from "../Message/Message";

// While Bo's reply is pending, shows the streamed partial response once chunks
// start arriving, the running tool call if one is in flight, otherwise a typing
// indicator. Reads the shared chatbot slice, so it works for any chat screen
// that sends through `sendGeneralMessage`.
export const PendingBoMessage = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  const sendMessageStatus = useAppSelector(selectSendMessageStatus);
  const streamingResponse = useAppSelector(selectStreamingResponse);
  const isStreaming = useAppSelector(selectIsStreaming);
  const activeToolCall = useAppSelector(selectActiveToolCall);
  const completedToolCalls = useAppSelector(selectCompletedToolCalls);

  if (sendMessageStatus !== "loading") {
    return null;
  }

  const completedToolCallAccordions = completedToolCalls.length > 0 && (
    <div className="flex flex-col gap-0.5 mb-1">
      {completedToolCalls.map((tc, i) => (
        <ToolCallCompleted
          key={i} // NOSONAR: append-only list with no stable id; labels can repeat
          label={tc.label}
          success={tc.success}
        />
      ))}
    </div>
  );

  if (isStreaming && streamingResponse) {
    return (
      <>
        {completedToolCallAccordions}
        <Message
          role="BO"
          content={streamingResponse}
          sentTimeStamp={DateTime.local()}
        />
      </>
    );
  }

  if (activeToolCall) {
    return (
      <>
        {completedToolCallAccordions}
        <Stack direction="row" columnGap=".5rem" maxWidth="75%">
          <BoAvatar />
          <Box marginTop=".5rem">
            <ToolCallPending label={activeToolCall} />
          </Box>
        </Stack>
      </>
    );
  }

  return (
    <>
      {completedToolCallAccordions}
      <Stack direction="row" columnGap=".5rem" maxWidth="75%">
        <BoAvatar />
        <Box
          className={isDark ? "bg-teamApp-dark-surface" : "bg-white"}
          borderRadius=".25rem .75rem .75rem .75rem"
          padding="1rem"
          marginTop=".5rem"
          boxShadow={
            isDark
              ? "0px 4px 8px 0px var(--team-app-shadow-dark-heavy)"
              : "0px 4px 8px 0px #0020511a"
          }
        >
          <div className="typing-dots">
            <div className="dot" />
            <div className="dot" />
            <div className="dot" />
          </div>
        </Box>
      </Stack>
    </>
  );
};
